














import { Component, Vue } from 'vue-property-decorator';
import { Character } from '@/bindings/Character'
import { CharacterType } from './bindings/CharacterType';
import { RarityChances } from './bindings/RarityChances';
import { directive } from 'vue/types/umd';

// 
@Component({
  components: {

  },
  computed:{
  },
  data() {
    return {
      import :{CharacterData} , from: '../../character.ts',
      popup: true,
      routes: [
        {
          path: '/About',
          name: 'Cookie Run Kingdom Wish Simulator',
        },
        {
          path: '/',
          name: 'Standard',
        },
        {
          path: '/Featured',
          name: 'Featured',
        },
        // {
        //   path: '/history',
        //   name: 'History',
        // }
      ]
    }
  },
  mounted() {  
    
  },
  methods: {
    clicked() {
      alert("Error 502")
    },
        roll() {
      return Math.round(Math.random()* 100000)/1000
    }
  }
})



export default class Home extends Vue {}
